// internal
import { axios, def, handleError } from './internal';

// Deep link /@username → public user object, or null when missing/inactive.
function UserByUsername(username) {
    return axios
        .get(`/api/users/by-username/${encodeURIComponent(username)}`, { guest: true })
        .then((res) => (res.data.code === def.ErrorCode.OK ? res.data.data.user : null))
        .catch((err) => {
            handleError(err);
            return null;
        });
}

export { UserByUsername };
